<template>
  <HomeCommonLayout>
    <template #content>
      <RenewalContent>
        <IndexContent />
      </RenewalContent>
    </template>
  </HomeCommonLayout>
</template>

<script setup lang="ts">
import { useSiteNavigationLd, useOrganizationLd } from "#imports";
import IndexContent from "~~/codepresso-renewal/content/IndexContent.vue";
import { useSeoMeta } from "~/composables/useSeoMeta";

const siteLinkScript = useSiteNavigationLd();
const organizationScript = useOrganizationLd();
const { getCanonical, getHreflangLinks } = useSeoMeta();

useHead({
  title: '기업 AI 활용 역량 진단·교육 플랫폼 | 코드프레소',
  meta: [
    {
      name: 'description',
      content: '기업, 대학, 공공기관 구성원의 AI 활용 역량을 진단하고 맞춤 교육으로 연결합니다. 개인·조직 단위 리포트로 AI 역량 성장을 확인하세요.'
    },
    {
      name: 'title',
      content: '기업 AI 활용 역량 진단·교육 플랫폼 | 코드프레소'
    },
    {
      name: 'robots',
      content: 'index,follow'
    },
    {
      property: 'og:title',
      content: 'AI 활용 역량, 진단부터 교육까지 | 코드프레소'
    },
    {
      property: 'og:description',
      content: 'AI를 쓰는 사람과 AI를 다루는 사람은 다릅니다. 코드프레소가 그 차이를 측정하고 성장시킵니다.'
    },
    {
      property: 'og:locale',
      content: 'ko_KR'
    }
  ],
  script: [siteLinkScript, organizationScript],
  link: [...getHreflangLinks.value, { rel: "canonical", href: getCanonical.value }],
});

definePageMeta({
  alias: [
    '/en',
    '/ja',
    '/ko',
  ]
})
</script>

<style>
/* renewal 의 임베드 빌드 산출물(codepresso-renewal/embed). 모든 셀렉터가
   `.renewal-root` 를 요구하므로 헤더·푸터로 새지 않는다.
   로딩 순서는 renewal 원본과 같게 main → 페이지 전용 → mobile 로 둔다. */
@import "../../codepresso-renewal/embed/css/main.css";
@import "../../codepresso-renewal/embed/css/pages/index.css";
@import "../../codepresso-renewal/embed/css/mobile.css";
</style>
